import React from 'react';
import styles from './styles.module.scss';

const GuideBar = ({
  guideMapping,
  labels,
  ariaLabel,
}: {
  guideMapping: number[] | undefined;
  labels?: string[];
  ariaLabel?: string;
}) => {
  const whiteCell = (index: number) => <span key={`cell${index}`}></span>;
  const blackCell = (index: number) => <span key={`cell${index}-filled`} className={styles.filledCell}></span>;
  const guideBar = guideMapping
    ? guideMapping.map((cellStatus, index) => {
        return cellStatus === 1 ? blackCell(index) : whiteCell(index);
      })
    : null;

  const barLabels = labels
    ? labels.map((str) => (
        <span className={str.toLowerCase() === 'warmer' ? styles.center : ''} key={`label-${str}`}>
          {str}
        </span>
      ))
    : null;

  return (
    <div aria-label={ariaLabel} className={styles.guideBar}>
      <div className={styles.bar}>{guideBar}</div>
      {barLabels && <div className={styles.barLabels}>{barLabels}</div>}
    </div>
  );
};

export default GuideBar;
